/**
 * In development mode, logs the intended action.
 */
export const executeSafely = <R>(
  actionDescription: string,
  actionFn: () => R,
): R | undefined => {
  if (process.env.NODE_ENV === 'development') {
    alert(`[DEV ONLY] ${actionDescription}`);
    return undefined;
  } else {
    return actionFn();
  }
};
